import api from '@/api';

import { PageRequest } from '@/core/request/PageRequest';
import { PageResult } from '@/core/request/PageResult';

import {
  Diagnostic,
  DiagnosticCreate,
  DiagnosticGenerateWorkOrder,
  DiagnosticGenerateWorkOrderReponse,
  DiagnosticPart,
} from './Diagnostics.types';

import { API_BASE_URL } from '..';

const CONTROLLER_URL = `${API_BASE_URL}/diagnostics`;

export async function listDiagnostics(params: PageRequest) {
  const result = (await api.get(`${CONTROLLER_URL}`, params)) as unknown;

  return result as PageResult<Diagnostic>;
}

export async function listDiagnosticPats(params: PageRequest) {
  const result = (await api.get(`${CONTROLLER_URL}/parts`, params)) as unknown;

  return result as PageResult<DiagnosticPart>;
}

export const getDiagnostic = async (diagnosticId?: number) => {
  const result = (await api.get(
    `${CONTROLLER_URL}/${diagnosticId}`,
    null,
  )) as unknown;

  return result as Diagnostic;
};

export const createDiagnostic = async (diagnostic: DiagnosticCreate) => {
  const result = (await api.post(
    `${CONTROLLER_URL}`,
    diagnostic,
    null,
  )) as unknown;

  return result as Diagnostic;
};

export const updateDiagnostic = async (
  diagnostic: DiagnosticCreate & { id: number },
) => {
  const result = (await api.put(
    `${CONTROLLER_URL}/${diagnostic.id}`,
    diagnostic,
    null,
  )) as unknown;

  return result as Diagnostic;
};

export const removeDiagnostic = async (diagnosticId: number) => {
  const result = api.remove(
    `${CONTROLLER_URL}/${diagnosticId}`,
    {},
    null,
  ) as unknown;

  return result as void;
};

export const reportDiagnostic = async (diagnosticId: number) => {
  const result = api.getReport(`${CONTROLLER_URL}/${diagnosticId}/report`, {
    responseType: 'blob',
  }) as unknown;

  return result as Blob;
};

export const generateWorkOrderDiagnostic = async (
  obj: DiagnosticGenerateWorkOrder,
) => {
  const result = (await api.post(
    `${CONTROLLER_URL}/workorder`,
    obj,
    null,
  )) as unknown;

  return result as DiagnosticGenerateWorkOrderReponse;
};
